import { put, takeLatest } from 'redux-saga/effects';
import api from '../../../../utils/apiConfig';
import OperatorTdsDeclarationTypes from './types';
import {
  fetchOperatorDetailsSuccess,
  fetchOperatorDetailsFailure,
  initiateOperatorTdsDeclarationSuccess,
  initiateOperatorTdsDeclarationFailure,
} from './actions';
import urlHelper from './urls';

function* getOperatorTdsDetailsSaga(action: any) {
  const requestURL: any = urlHelper.getOperatordetails(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(fetchOperatorDetailsSuccess(response));
  } catch (e) {
    yield put(fetchOperatorDetailsFailure(e));
    console.log({ e });
  }
}

function* getInitiateTdsDeclarationSaga(action: any) {
  const requestURL = urlHelper.initiateTdsDeclaration(action.payload);
  try {
    const response = yield api.get(requestURL);
    yield put(initiateOperatorTdsDeclarationFailure(response));
  } catch (e) {
    yield put(initiateOperatorTdsDeclarationSuccess(e));
    console.log({ e });
  }
}

function* operatorTdsDeclarationSaga() {
  yield takeLatest(OperatorTdsDeclarationTypes.FETCH_OPERATOR_DETAILS_START, getOperatorTdsDetailsSaga);
  yield takeLatest(OperatorTdsDeclarationTypes.INITIATE_OPERATOR_TDS_DECLARATION_START, getInitiateTdsDeclarationSaga);
}
export default operatorTdsDeclarationSaga;
